import ordinal from 'ordinal';

import { MIDDLE_HIGH_SCHOOL_GRADES, GRADE_YEARS } from 'constants/gradeYears';

const getGradeFilter6Through11Only = response => {
  const allGradeYears = MIDDLE_HIGH_SCHOOL_GRADES;
  const formattedData = response.data
    .filter(entry => allGradeYears.includes(Number(entry)))
    .sort((a, b) => Number(a) - Number(b))
    .map(entry => ({
      id: entry,
      name: ordinal(entry),
      // eslint-disable-next-line dot-notation
      disabled: entry === GRADE_YEARS['_12'],
    }));

  return {
    key: 'grades',
    source: 'grades',
    filterName: 'Grades',
    searchable: false,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
  };
};

export default getGradeFilter6Through11Only;
